import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { isEmpty } from "lodash";
import { Button, Form } from "react-bootstrap";
const Setting = ({ setting, setSetting }) => {
  const [isLoader, setLoader] = useState(false);
  const [mainStake, setMainStake] = useState([]);
  const [stakedata, setStakeData] = useState([]);
  const [okShown, setOkShown] = useState(true);
  const [editShown, setEditShown] = useState(false);
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({});
  const onSubmit = async (request) => {
    setLoader(true);

    if (!isEmpty(mainStake) && mainStake.length > 5) {
      try {
        const { status, data: response_users } = await apiPost(
          apiPath.userProfileUpdate,
          {
            defaultStake: request.defaultStake,
            stake: mainStake,
          }
        );
        if (status === 200) {
          if (response_users.success) {
            setLoader(false);
            getProfileData();
            setMainStake(response_users?.results?.stake);
            setSetting(false);
          } else {
            setLoader(false);
          }
        }
        setLoader(false);
      } catch (err) {
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
  };
  const handleOkClick = async (event) => {
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.userEditStake,
        { editStake: stakedata }
      );
      if (status === 200) {
        if (response_users.success) {
        } else {
        }
      }
    } catch (err) {}

    stakedata.sort((a, b) => a - b);
    setOkShown(true);
    setEditShown(false);
  };
  useEffect(() => {
    if (!isEmpty(profileData)) {
      const editStake = profileData?.editStake ?? [];
      const stake = profileData?.stake ?? [];

      const editStakeSet = new Set(editStake);
      setStakeData(editStake.sort((a, b) => a - b));
      const commonStake = stake.filter((i) => editStakeSet.has(i));
      setValue("defaultStake", profileData?.defaultStake || 0);
      setMainStake(commonStake);
    }
  }, [profileData]);
  const setStakeShow = (value) => {
    let main = [...mainStake];
    const index = main.indexOf(value);
    if (mainStake.length < 6) {
      if (index === -1) {
        main.push(value);
      } else {
        main.splice(index, 1);
      }
    } else {
      if (index === -1) {
        main.sort((a, b) => a - b);
        main.shift();
        main.push(value);
      } else {
        main.splice(index, 1);
      }
    }
    setMainStake(main);
  };
  const handleStake = (e, i) => {
    let values = [...stakedata];
    values[i] = parseInt(Number(e.target.value));
    setStakeData(values);
  };
  const handleEditClick = (event) => {
    setEditShown(true);
    setOkShown(false);
  };
  return (
    <div
      className="overlay right-side"
      id="settingDiv"
      style={{ display: setting ? "flex" : "none" }}
    >
      <div className="side-wrap setting-wrap" id="settingSlide">
        <div className="side-head">
          <h3 className="a-setting">
            <img src={require("../../assets/images/transparent.gif")} />
            Setting
          </h3>
          <a
            onClick={() => setSetting(false)}
            className="close ui-link"
            href="#"
            id="settingClose"
          />
        </div>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          id="coinList"
          className="side-content"
        >
          <h3>Stake</h3>
          <dl className="setting-block">
            <dt>
              Default stake
              <input
                type="number"
                id="userCoin"
                defaultValue
                pattern="[0-9]*"
                data-role="none"
                {...register("defaultStake")}
              />
            </dt>
          </dl>{" "}
          {okShown && (
            <dl id="stakeSet" className="setting-block stake-setting">
              <dt>Quick Stakes</dt>
              {stakedata &&
                stakedata.map((item, index) => {
                  return (
                    <dd key={index + 1}>
                      <a
                        href="#"
                        id={"coin_" + index + 1}
                        className={
                          mainStake.includes(item) ? "btn select" : "btn"
                        }
                        onClick={() => setStakeShow(item)}
                      >
                        {item}
                      </a>
                    </dd>
                  );
                })}
              <dd onClick={handleEditClick} className="col-stake_edit">
                <a href="#" id="edit" className="btn-edit ui-link">
                  Edit Stakes
                </a>
              </dd>
            </dl>
          )}{" "}
          {editShown && (
            <dl
              id="editCustomizeStakeList"
              className="setting-block stake-setting"
              style={{ display: "flex" }}
            >
              <dt>Quick Stakes</dt>
              {stakedata &&
                stakedata.map((item, index) => {
                  return (
                    <dd>
                      <div
                        key={index + 1}
                        className="ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"
                      >
                        <input
                          id="stakeEdit_1"
                          type="text"
                          name="stake[]"
                          pattern="[0-9]*"
                          value={item}
                          onChange={(e) => handleStake(e, index)}
                        />
                      </div>
                    </dd>
                  );
                })}

              <dd onClick={handleOkClick} className="col-stake_edit">
                <a href="#" id="ok" className="btn-send ui-link">
                  OK
                </a>
              </dd>
            </dl>
          )}
          <h3>Odds</h3>
          <dl className="setting-block">
            <dt>Highlight when odds change</dt>
            <dd>
              <a className="switch_on" href="#" id="enableSparkCheck">
                <input type="hidden" id="sparkValue" defaultValue={1} />
                <span />
              </a>
            </dd>
          </dl>
          <h3>FancyBet</h3>
          <dl className="setting-block">
            <dt>Accept Any Odds</dt>
            <dd>
              <a
                id="fancyBetAcceptAnyOddsCheckBox"
                className="switch_on"
                href="#"
              >
                <span />
              </a>
            </dd>
          </dl>
          <h3>SportsBook</h3>
          <dl className="setting-block">
            <dt>Accept Any Odds</dt>
            <dd>
              <a
                id="sportsBookAcceptAnyOddsCheckBox"
                className="switch_on"
                href="#"
              >
                <span />
              </a>
            </dd>
          </dl>
          <h3>Win Selection forecast</h3>
          <dl className="setting-block">
            <dt>With Commission</dt>
            <dd>
              <a id="withCommCheckBox" className="switch_off" href="#">
                <span />
              </a>
            </dd>
          </dl>
          <ul className="btn-list">
            <li>
              <Button
                onClick={() => setSetting(false)}
                disabled={editShown ? true : ""}
                id="settingCancel"
                className="btn ui-link w-100"
                style={{ width: "100%" }}
              >
                Cancel
              </Button>
            </li>
            <li>
              <Button
                type="submit"
                disabled={editShown ? true : ""}
                id="settingSave"
                className="btn-send ui-link w-100"
                style={{ width: "100%" }}
              >
                Save
              </Button>
            </li>
          </ul>
        </Form>
      </div>
    </div>
  );
};

export default Setting;
